export default angular.module("mars.vet.dnareports.controllers.traits",[]).controller('TraitsController', function($rootScope, $scope, $window, $routeParams, EntryIDService, NavigationService, EntryService, TranslationService, UtilityService,reportdata) {
    'ngInject';
    let entryID = $routeParams.entryID;
    let resultString = reportdata.resultString;
    let sampleDetails = reportdata.sampleDetails;

    $scope.getVersionFeature = UtilityService.getVersionFeature('Traits');
    var traitsData = resultString.traits;
    var reportType = 'online';
    $scope.onloadFun = function() {
        reportType = 'pdf';
    }
    if ($scope.getVersionFeature) {
        EntryService.getEntry(EntryIDService.getEntryID('Traits')).then(function(response) {
            var fields = response.fields;
            if (reportType != 'pdf') {
                $rootScope.pageTitle = fields.title;
            }
            $scope.title = fields.title;
            $scope.mainDescription = fields.description.replaceAll("[DOG NAME]", sampleDetails.petDetails.petName);;
            $scope.getVersionFeature = UtilityService.getVersionFeature('Traits');
            $scope.getTranslation = TranslationService.getTranslation;
            $window.ga('send', 'pageview', {
                'page': $rootScope.pageTitle
            });
            $scope.traitsArray = traitsData;
            NavigationService.setNavigationUrls();
        }, function(error) {
            // promise rejected, could log the error with:
            // console.log('error', error);
        });
    }
}).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/controllers/traits.controller.js